import { render, staticRenderFns } from "./MatchRules.vue?vue&type=template&id=1bd404ae&scoped=true"
import script from "./MatchRules.vue?vue&type=script&lang=js"
export * from "./MatchRules.vue?vue&type=script&lang=js"
import style0 from "./MatchRules.vue?vue&type=style&index=0&id=1bd404ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd404ae",
  null
  
)

export default component.exports